import {
  Attribute,
  BelongsTo,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { Member } from './member.model';
import { VirtualLocation } from './virtual-location.model';
import { PhysicalLocation } from './physical-location.model';

@JsonApiModelConfig({
  type: 'meetings',
})
export class Meeting extends JsonApiModel {
  @Attribute()
  headline!: string;

  @Attribute()
  description!: string;

  @Attribute({ serializedName: 'organizer_name' })
  organizerName!: string;

  @Attribute({ serializedName: 'duration_in_minutes' })
  durationInMinutes!: string;

  @Attribute({ serializedName: 'organizer_id' })
  organizerId!: number;

  @BelongsTo({ key: 'physical_location' })
  physicalLocation!: PhysicalLocation;

  @BelongsTo({ key: 'virtual_location' })
  virtualLocation!: VirtualLocation;

  @BelongsTo({ key: 'organizer' })
  meetingOrganizer!: Member;
}
